export const WEIGHT_UOMS = ['KG', 'LB'];
export const VOLUME_UOMS = ['CBM', 'CFT'];
export const DOC_TYPES = ['PL', 'CIPL', 'OTHER'];
